import React from "react";
import { Chip } from "@material-ui/core";
import DetailSection from "./DetailSection";
import SimpleTable from "./SimpleTable";
import Link from "./Link";
import Typography from "@material-ui/core/Typography";
import Time from "../lithic/Moment";

export default function CreditMonitoringsTable({ creditMonitorings }) {
  return (
    <DetailSection title="Credit Monitorings" mt={5}>
      {creditMonitorings && creditMonitorings.length > 0 ? (
        <SimpleTable
          truncated
          tableProps={{ size: "small" }}
          headers={["ID", "Status", "Identity ID", "Enrolled On", "Last Pulled At"]}
          rows={creditMonitorings}
          keyRowAttr="id"
          toCells={(row) => [
            <Link key={1} to={`/credit-monitorings/${row.id}`}>
              {row.id}
            </Link>,
            row.active ? (
              <Chip key={2} size="small" label="Active" style={{ backgroundColor: "#4caf50", color: "#fff" }} />
            ) : (
              <Chip key={2} size="small" label="Inactive" />
            ),
            <Link key={2} to={`/identities/${row.identityId}`}>
              {row.identityId}
            </Link>,
            row.enrolledOn ? (
              <Time key={3} formatExact ="MMM DD, YYYY">
                {row.enrolledOn}
              </Time>
            ) : (
              "(not set)"
            ),
            row.lastPulledAt ? (
              <Time key={3} formatExact="MMM DD, YYYY">
                {row.lastPulledAt}
              </Time>
            ) : (
              "(not set)"
            ),
          ]}
        />
      ) : (
        <Typography variant="body2" color="textSecondary">
          No credit monitorings found.
        </Typography>
      )}
    </DetailSection>
  );
}
